import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Pages
        {
          name: 'Inicio',
          path: '.',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Maestro de Productos',
          path: 'pages/Productos',
          component: () => import('@/views/dashboard/pages/Mproductos'),
        },
        {
          name: 'Maestro de Marca del producto',
          path: 'pages/MarcaP',
          component: () => import('@/views/dashboard/pages/Mmarcaproducto'),
        },
        {
          name: 'Maestro de Marcas',
          path: 'pages/Marcas',
          component: () => import('@/views/dashboard/pages/Mmarcas'),
        },
        {
          name: 'Maestro de Modelo',
          path: 'pages/Modelo',
          component: () => import('@/views/dashboard/pages/Mmodelos'),
        },
        {
          name: 'Inventario',
          path: 'pages/Inventario',
          component: () => import('@/views/dashboard/pages/inventario'),
        },
        {
          name: 'Maestro de Usuario',
          path: 'pages/usuarios',
          component: () => import('@/views/dashboard/pages/Usuarios'),
        },
        {
          name: 'Maestro de Clientes',
          path: 'pages/Clientes',
          component: () => import('@/views/dashboard/pages/Clientes'),
        },
        {
          name: 'Orden de trabajo',
          path: 'pages/orden',
          component: () => import('@/views/dashboard/pages/ordentrabajo'),
        },
      ],
    },
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/dashboard/Login'),
    },
    {
      name: 'registro',
      path: '/registro',
      component: () => import('@/views/dashboard/registro'),
    },
    {
      name: 'Recuperar',
      path: '/recuperar',
      component: () => import('@/views/dashboard/recuperar'),
    },
    {
      name: 'recuperar',
      path: '/recu/:token/:uid',
      component: () => import('@/views/dashboard/recuperarconfirm'),
    },
  ],
})
